export const TRANSLATION_KEYS = {
  REVIEW_TITLE: "REVIEW_TITLE",
  TOTAL_RATING_COUNT: "TOTAL_RATING_COUNT",
  WRITE_REVIEW_TITLE: "WRITE_REVIEW_TITLE",
  WRITE_REVIEW_HELP: "WRITE_REVIEW_HELP",
  WRITE_REVIEW_CTA: "WRITE_REVIEW_CTA",
}
